export default __webpack_public_path__ + "static/media/hive logo HD.79182744.png";